// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2rHcA","footer":"ChangeClinic_footer__29ERv"};